import {formatDateTime} from '../utils/formatDateTime';
import {getCurrentCompanyLocationId} from '../utils/getCurrentCompanyLocationId';

const mapContainer1 =  document.querySelector('#c-box-forecast-changes-charts__chart--1');
const mapContainer2 =  document.querySelector('#c-box-forecast-changes-charts__chart--2');

if (mapContainer1) {
    google.charts.load('current', {
        callback: function () {
            drawChart1();
            window.addEventListener('resize', (e) => {
                drawChart1();
            });
        },
        packages: ['corechart']
    });
}

if (mapContainer2) {
    google.charts.load('current', {
        callback: function () {
            drawChart2();
            window.addEventListener('resize', (e) => {
                drawChart2();
            });
        },
        packages: ['corechart']
    });
}

/*
* Chart 1 - Temperature Ranges.
* */
function drawChart1() {
    let currentCompanyId = getCurrentCompanyLocationId();
    let apiUrl = `/api/company-location/${currentCompanyId}/weather-forecast/daily`;

    fetch(apiUrl)
        .then(response => {
            return response.json();
        })
        .then(data => {
            const days = data.days;
            let dataArr = [];

            /*
            * Box Date Range.
            * */
            const dayFirst = formatDateTime(days[0].day);
            const dayLast = formatDateTime(days[6].day);
            const monthFirst = dayFirst.month + 1;
            const monthLast = dayLast.month + 1;

            document.querySelector('.c-box-forecast-changes-charts .c-box__header__meta').innerHTML = `${dayFirst.day}.${monthFirst} - ${dayLast.day}.${monthLast}.${dayLast.year}`;

            for (let i = 0; i < 7; i++) {
                let dataArrRow = [];
                let dateTime = formatDateTime(days[i].day);
                let dayDate = new Date(dateTime.year, dateTime.month, dateTime.day);

                dataArrRow.push(dayDate);
                dataArrRow.push(days[i].temperatureMin);
                dataArrRow.push(days[i].temperatureMax);
                dataArrRow.push(days[i].temperatureMin);
                dataArrRow.push(days[i].temperatureMax);

                dataArr.push(dataArrRow);
            }

            return dataArr;
        })
        .then(dataArr => {
            chart1Draw(dataArr, options);
        })
        .catch(err => {
            console.log('Problem with chart #1 drawing.');
        });

    /*
    * Draw Chart based on data from API.
    * */
    const chart1Draw = (dataArr, options) => {
        let dataChart = google.visualization.arrayToDataTable(dataArr, true);

        let chart1 = new google.visualization.CandlestickChart(document.getElementById('c-box-forecast-changes-charts__chart--1'));

        chart1.draw(dataChart, options);

        const bars = document.querySelectorAll('#c-box-forecast-changes-charts__chart--1 svg > g > g > g:nth-child(3) > g');

        let gradientDef = `
                <linearGradient id="candle-stick-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" stop-color="#df2935" />
                  <stop offset="50%" stop-color="#ffcd00" />
                  <stop offset="100%" stop-color="#28965a" />
                </linearGradient>
            `;

        for (let i = 0; i < bars.length; i++) {
            const bar = bars[i];
            bar.innerHTML += gradientDef;

            let rectsElements = bar.querySelectorAll('rect');
            rectsElements.forEach(el => {
                el.style.fill = 'url(#candle-stick-gradient)';
            });

            let barRects = bar.childNodes[0];
            let boundingBox = barRects.getBBox();

            const svgns = "http://www.w3.org/2000/svg";

            let textTop = document.createElementNS(svgns, 'text');
            textTop.setAttribute('x', boundingBox.x - 10);
            textTop.setAttribute('y', (boundingBox.y - 5));
            textTop.setAttribute('height', '20');
            textTop.setAttribute('width', '30');
            textTop.setAttribute('display', 'block');
            textTop.setAttribute('font-size', '10px');
            textTop.setAttribute('font-weight', 'bold');
            textTop.setAttribute('fill', '#3c3c3b');
            textTop.innerHTML = dataArr[i][2] + '\xB0';
            bar.appendChild(textTop);

            let textBottom = document.createElementNS(svgns, 'text');
            textBottom.setAttribute('x', boundingBox.x - 10);
            textBottom.setAttribute('y', (boundingBox.y + 10 + boundingBox.height));
            textBottom.setAttribute('height', '20');
            textBottom.setAttribute('width', '30');
            textBottom.setAttribute('display', 'block');
            textBottom.setAttribute('font-size', '10px');
            textBottom.setAttribute('font-weight', 'bold');
            textBottom.setAttribute('fill', '#3c3c3b');
            textBottom.innerHTML = dataArr[i][3] + '\xB0';
            bar.appendChild(textBottom);

        }
    }

    let options = {
        legend: {
            position: 'none'
        },
        backgroundColor: {
            fill: '#fff',
            fillOpacity: 1
        },
        chartArea: {
            top: 10,
            left: 30,
            right: 0,
            height: '80%',
            width: '100%'
        },
        fontSize: 12,
        width: '100%',
        height: 300,
        candlestick: {
            fallingColor: {
                strokeWidth: 0,
                fill: 'url(#candle-stick-gradient)',
            },
            risingColor: {
                strokeWidth: 0,
                fill: 'url(#candle-stick-gradient)',
            }
        },
        tooltip: {
            trigger: 'none'
        },
        enableInteractivity: false,
        hAxis: {
            gridlines: {
                color: '#e5e5e5',
                count: 7
            },
            format: 'dd.MM'
        },
        vAxis: {
            gridlines: {
                color: '#e5e5e5'
            }
        },
        bar: {
            groupWidth: 13
        }
    };
}

/*
* Chart 2 - Wind and Rainfall/Snowfall.
* */
function drawChart2() {
    let currentCompanyId = getCurrentCompanyLocationId();
    let apiUrl = `/api/company-location/${currentCompanyId}/weather-forecast/daily`;

    fetch(apiUrl)
        .then(response => {
            return response.json();
        })
        .then(dataChart => {
            const days = dataChart.days;

            let data = new google.visualization.DataTable();

            data.addColumn('datetime', 'Date');
            // data.addColumn('number', 'Warning');
            // data.addColumn('number', 'Warning');
            data.addColumn('number', 'Opady');
            data.addColumn({
                type: 'string',
                role: 'annotation'
            });
            data.addColumn('number', 'Wiatr');
            data.addColumn({
                type: 'string',
                role: 'annotation'
            });
            data.addColumn({
                role: 'style',
                type: 'string'
            });
            // data.addColumn('number', 'Wind');

            let pointStyle = "point { size: 4; shape-type: circle; fill-color: #ffffff; opacity: 1; stroke-color: #ffcd00; stroke-width: 2}";

            let dataRows = [];
            for (let i = 0; i < 7; i++) {
                let dataRow = [];
                let dateTime = formatDateTime(days[i].day);
                let dayDate = new Date(dateTime.year, dateTime.month, dateTime.day);

                let wind = days[i].wind;
                let windLabel = (wind) ? `${wind} km/h` : '';
                let fall = (days[i].rain !== null) ? days[i].rain : days[i].snow;
                let fallLabel = (fall) ? `${fall} mm` : '';

                dataRow.push(dayDate);
                dataRow.push(fall);
                dataRow.push(fallLabel);
                dataRow.push(wind);
                dataRow.push(windLabel);
                dataRow.push(pointStyle);

                dataRows.push(dataRow);
            }

            data.addRows(dataRows);

            let options2 = {
                legend: {
                    position: 'none'
                },
                backgroundColor: {
                    fill: '#fff',
                    fillOpacity: 1
                },
                chartArea: {
                    top: 10,
                    left: 30,
                    right: 30,
                    height: '80%',
                    width: '100%'
                },
                fontSize: 12,
                width: '100%',
                height: 300,
                series: {
                    // Opady
                    0: {
                        targetAxisIndex: 0,
                        color: '#81c5d3',
                        type: 'bars',
                    },
                    // Wiatr
                    1: {
                        targetAxisIndex: 1,
                        color: '#ffcd00',
                        type: 'line',
                    },
                },
                vAxis: {
                    vAxis: {
                        viewWindow: {
                            min: 0
                        }
                    },
                },
                annotations: {
                    alwaysOutside: true,
                    highContrast: true,
                    textStyle: {
                        fontSize: 11,
                        opacity: 1,
                        bold: true
                    }
                },
                hAxis: {
                    format: 'dd.MM',
                    gridlines: {
                        color: '#e5e5e5',
                    }
                },
                curveType: 'function',
                pointSize: 10,
                crosshair: {
                    trigger: 'both'
                }
            };

            let chart2 = new google.visualization.ComboChart(document.getElementById('c-box-forecast-changes-charts__chart--2'));

            chart2.draw(data, options2);
        })
        .catch(err => {
            console.log('Problem with chart #2', err);
        });
}
